import { type FC } from 'react'

import {
  type OfferV11,
  type PimProductWithVariantsV1,
} from '@redteclab/api/clients/bully'
import { type SellerPromotionV2 } from '@redteclab/api/clients/composition-service-transactions'
import { IconInfo } from '@redteclab/icons'

import { useExperimentsContext } from '../../../../../../experiments/components/ExperimentsContext'
import { EXPERIMENT_NAME_MARKETPLACE_HARMONISATION_PDP } from '../../../../../../experiments/model/EXPERIMENT_NAME'
import { useOpenableControls } from '../../../../../../generic-hooks'
import { ProductSellerPromotionFlag } from '../../../../ProductSellerPromotionFlag/ProductSellerPromotionFlag'
import { ProductHeadGenericLabel } from '../../ProductHeadGenericLabel/ProductHeadGenericLabel'

import { ProductPageSellerPromotionModal } from './ProductPageSellerPromotionModal'

export const ExperimentMarketplaceSellerPromotionHarmonisation: FC<{
  offer: OfferV11
  product: PimProductWithVariantsV1
  sellerPromotion: SellerPromotionV2
}> = ({ offer, product, sellerPromotion }) => {
  const { handleClose, handleOpen, isOpen } = useOpenableControls()
  const { addExperimentKeysForActivation } = useExperimentsContext()

  return (
    <>
      <ProductHeadGenericLabel
        className="border-light-primary-strong bg-light-tertiary"
        data-qa-id="product-label-seller-promotion"
        onClick={() => {
          handleOpen()
          addExperimentKeysForActivation(
            EXPERIMENT_NAME_MARKETPLACE_HARMONISATION_PDP,
          )
        }}
      >
        <ProductSellerPromotionFlag sellerPromotion={sellerPromotion} />
        <IconInfo className="ml-1 size-4 shrink-0" />
      </ProductHeadGenericLabel>
      <ProductPageSellerPromotionModal
        dialogTitle={
          <ProductSellerPromotionFlag sellerPromotion={sellerPromotion} />
        }
        isOpen={isOpen}
        offer={offer}
        onClose={handleClose}
        product={product}
      />
    </>
  )
}
